import React from 'react';
import { Phone, MapPin, Clock, Globe, Mail } from 'lucide-react';
import "../styles/Contact.css";

export default function ContactSection() {
  return (
    <section className="sec sec--white" id='ContactInfo'>
      <div className="container">
        <div className="sec-head">
          <span className="eyebrow">Get in touch</span>
          <h2 className="sec-title">Tell us what needs cleaning</h2>
          <p className="sec-lede">
            Quotes are free and we answer the phone around the clock.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-map">
            <div className="contact-map__frame">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d423286.27405770525!2d-118.69192047471653!3d34.02016130653294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c75ddc27da13%3A0xe22fdf6f254608f4!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1653688056!5m2!1sen!2s"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Service map"
              ></iframe>
            </div>
            <div className="contact-map__area">
              <Globe size={20} aria-hidden="true" />
              <p>
                <b>Service area</b>
                Los Angeles, Santa Monica, Culver City, Beverly Hills, Malibu,
                Pacific Palisades, South Bay, Long Beach y Palos Verdes, CA.
              </p>
            </div>
          </div>

          <div className="contact-details">
            <div className="contact-cards">
              <div className="contact-card">
                <Phone size={22} aria-hidden="true" />
                <h3>Phone</h3>
                <a href="tel:+13109254824" className="mono">(310) 925-4824</a>
              </div>

              <div className="contact-card">
                <Mail size={22} aria-hidden="true" />
                <h3>E-mail</h3>
                <a href="mailto:info@sunshinecleaningall.com">
                  info@sunshinecleaningall.com
                </a>
              </div>

              <div className="contact-card">
                <MapPin size={22} aria-hidden="true" />
                <h3>Location</h3>
                <p>Los Angeles, CA</p>
              </div>

              <div className="contact-card">
                <Clock size={22} aria-hidden="true" />
                <h3>Availability</h3>
                <p className="mono">Available 24/7</p>
              </div>
            </div>

            <button
              type="button"
              className="btn-sun btn-lg-brand contact-cta"
              data-bs-toggle="modal"
              data-bs-target="#contactModal"
            >
              Request a quote
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
